import { createAction } from 'redux-actions'
import * as c from './constants'

export const features = {
  loading: createAction(c.FEATURES_LOADING),
  features: createAction(c.FEATURES, (client, desiredFeatures = {}, options = {}) =>
    client.get('/features', options).then(resp => {
      const enabledFeatures = resp.data
      const features = enabledFeatures
      Object.values(desiredFeatures).forEach(featureKey => {
        if (!features[featureKey]) {
          features[featureKey] = false
        }
      })
      return { data: features }
    })
  ),
  fetch: (client, desired = {}, options = {}) => [
    features.loading(),
    features.features(client, desired, options)
  ]
}
